import { Box, Button } from '@mui/material';
import { FieldProps } from '../../renderFieldView';
import { useStore } from '../../../../store/store';
import { Edit } from "@mui/icons-material";
import { EvaluationsContentDialog } from '../../../../screens/evaluations/components/EvaluationsContentDialog';
import { useUpdateRecord } from '../../../../api/useUpdateRecord';
import { useQueryClient } from '@tanstack/react-query';
import { WysiwygField } from '../WysiwygField';

type EvaluationsContentProps = FieldProps;

export const EvaluationsContent = ({ value, field, fieldView, extraOptions }: EvaluationsContentProps) => {
    const { appDialog } = useStore();
    const content = value?.[field.field] || null;
    const updateRecord = useUpdateRecord();
    const queryClient = useQueryClient();

    const handleOpenDialog = () => {
        appDialog.createDialog({
            title: field.headerName || "",
            allowSoftCancel: false,
            maxWidth: "lg",
            contentAndActions: (
                <EvaluationsContentDialog
                    field={field}
                    initialContent={content}
                    extraOptions={extraOptions}
                    onSave={async (updatedContent) => {
                        await updateRecord.mutateAsync({
                            data: { content_evaluation: updatedContent },
                            entity: "evaluations",
                            id: value.id,
                        });

                        const recordKeyPrefix = `evaluations-${value.id}`;
                        queryClient.setQueriesData(
                            { predicate: (query: any) => query.queryKey[0].startsWith(recordKeyPrefix) },
                            (oldData: any) => {
                                if (!oldData?.item) return oldData;
                                return { ...oldData, item: { ...oldData.item, content_evaluation: updatedContent } };
                            }
                        );
                    }}
                />
            ),
        });
    };


    return (
        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 4, flexDirection: "column" }}>
        {content && (
                <WysiwygField key={field.field} label={field.headerName || field.field} field={field} value={content} fieldView={fieldView} extraOptions={extraOptions} />
            )}
            <Button
                fullWidth
                sx={{ maxWidth: "100%" }}
                type="button"
                onClick={handleOpenDialog}
                startIcon={<Edit />}
            >
                Editar
            </Button>
        </Box>
    );
};
